module.exports = __webpack_public_path__ + "media/partners/pepsico-334396b5.svg";